import type {
  AnalysisFeature,
  AnalysisSimilarCase,
  ChromatogramPoint,
  MzRtPoint,
} from "@/types";
import type {
  FeatureData,
  MZRTData,
  SimilarCase,
  TICData,
} from "@/types/spectrum";

export function transformTICResponse(data: ChromatogramPoint[]): TICData[] {
  return data.map((point) => ({
    rt: point.rt,
    intensity: point.intensity,
  }));
}

export function transformMZRTResponse(data: MzRtPoint[]): MZRTData[] {
  return data.map((point) => ({
    rt: point.rt,
    mz: point.mz,
    intensity: point.intensity,
    feature_id: point.feature_id,
  }));
}

export function transformFeaturesResponse(
  data: AnalysisFeature[],
): FeatureData[] {
  return data.map((feature) => ({
    feature_id: feature.feature_id,
    result_id: feature.result_id,
    rt: feature.rt,
    rt_source: feature.rt_source,
    peak_no: feature.peak_no,
    observation_id: feature.observation_id,
    observation_size: feature.observation_size,
    candidate_rank: feature.candidate_rank,
    scan_index: feature.scan_index,
    scan_rank: feature.scan_rank,
    assessment_status: feature.assessment_status,
    assessment_count: feature.assessment_count,
    area: feature.area,
    top_mz: feature.top_mz,
    predicted_substance: feature.predicted_substance,
    matching_score: feature.matching_score,
    ai_note: feature.ai_note,
    suspicious: feature.suspicious,
    smiles: feature.smiles,
    jsd_distance: feature.jsd_distance,
    identification_engine: feature.identification_engine,
    database_source: feature.database_source,
    predicted_vp: feature.predicted_vp,
    predicted_solubility: feature.predicted_solubility,
  }));
}

export function transformSimilarCasesResponse(
  data: AnalysisSimilarCase[],
): SimilarCase[] {
  return data.map((c) => ({
    case_id: c.case_id,
    similarity: c.similarity,
    incident_type: c.incident_type,
    dominant_compounds: c.dominant_compounds.join(", "),
    date: c.date,
  }));
}
